import { instance } from "./axios";

export const updatePalletizedMeasurements = (payload, id) => {
    try {
        return instance.put(`/visit/palletized/${id}`, payload);
    } catch (error) {
        throw error;
    }
};